module.exports = __webpack_public_path__ + "static/media/Compras1.04064d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras1.png
// module id = 2066
// module chunks = 0